<template>
	<div class="scrollable only-y login-page align-vertical">
		<div class="form-wrapper align-vertical-middle">
			<div class="form-box card-base">
				<el-row :gutter="30" class="no-p no-m">
					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="p-30">
						<h1 class="mt-0 mb-10">
							{{ $t("login.login") }}
						</h1>
						<p class="pb-30">
							{{ $t("login.request_field") }}
						</p>
						<p class="pb-30">
							<el-alert v-if="errorLogin" title="Failed" type="error" description="more text description" show-icon></el-alert>
						</p>
						<form action="" @submit.prevent="login" :rules="rules" ref="loginForm">
							<float-label class="styled">
								<input type="text" required v-model="form.email" id="form-email" placeholder="Username / E-mail">
							</float-label>

							<float-label class="styled">
								<input :type="form.passwordFieldType" required v-model="form.password" placeholder="Password" >
								<span style="float:right; cursor:pointer; z-index: 2;" type="password" class="visibility" tabindex='-1' @click='switchVisibility' :arial-label='passwordVisible ? "Hide password" : "Show password"'>
									<el-button class="mdi mdi-eye ps-npr"></el-button>
								</span>
							</float-label>

							<div class="flex text-center center pt-30 pb-10 mt-10">
								<g-recaptcha 
									:data-sitekey="sitekey" 
									:data-validate="validate"
									:data-callback="callback"
									:data-btn-class="'el-button login-btn tada animated el-button--default is-round' + (loadingLogin ? ' is-loading' : '')">
									<i class="el-icon-loading" v-if="loadingLogin"></i> {{ $t("login.login") }}
								</g-recaptcha>
							</div>
						</form>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import gRecaptcha from '@finpo/vue2-recaptcha-invisible';
import api from '@/networkClient'
import config from '@/config'
const NodeRSA = require('node-rsa')
const key = new NodeRSA({b:512});
const pub = key.importKey(config.privateKey, 'pkcs1-public-pem');

export default {
	name: 'Login',
	components: {
		gRecaptcha
	},
	data() {
		return {
			sitekey: config.recaptcha.sitekey,
			passwordVisible:false,
			form: {
				email: '',
				password: '',
				passwordFieldType: 'password',
			},
			errorLogin: false,
			loadingLogin: false,
			windowWidth:window.innerWidth,
			rules: {
				email: [
					{ required: true, message: 'Please input email or username', trigger: 'blur' },
					{ min: 5, message: 'Character length too short', trigger: 'blur' }
				],
			}
		}
	},
	methods: {
		switchVisibility(){
			this.form.passwordFieldType = this.form.passwordFieldType === 'password' ? 'text' : 'password'
		},
		async login(token) {
			this.loadingLogin = true
			await api({
				method: 'post',
				url: config.baseApi + 'auth/login',
				data: { email: this.form.email, password: pub.encrypt(this.form.password, 'base64'), token: token },
				timeout: 10 * 1000
			}).then(response => {
				let data =
					response &&
					response.data &&
					response.data.data &&
					response.data.data.user
						? response.data.data.user
						: {};
				let status =
					response &&
					response.data &&
					response.data.ec
						? response.data.ec
						: null;
				if(status == 200){
					this.$store.commit('setLogin', data)
					this.$router.push('/dashboard')
				} else{
					this.$message.error({
						showClose: false,
						message: this.$t(`login.${response.data.message}`)
					});
				}
			}).catch(error => {
				this.$message.error({
					showClose: false,
					message: this.$t(`error_text`),
					type: 'error'
				});
			})
			this.loadingLogin = false
		},
		register() {
			this.$router.push('register')
		},
		validate(){
			if(_.isEmpty(this.form.email) && _.isEmpty(this.form.password)){
				this.$message.error({
					showClose: false,
					message: this.$t(`login.invalid_parameter`)
				});
				return false
			} else{
				return true
			}
		},
		async callback(token) {
			// google recaptcha token , then you can pass to backend with your form data .
			// console.log(token)
			if (token) {
				this.login(token)
				// alert(token);
			}else{
				// if you use data-size show reCAPTCHA , maybe you will get empty token.
				alert('Please check you are not robot');
			}
		},
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', () => {
				this.windowWidth = window.innerWidth
			});
		})
	},
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables';


.login-page {
	// background-color: #191d24;
	background: linear-gradient(45deg, rgba(25,29,36,1) 0%, rgba(85,85,85,1) 100%);
	// background: linear-gradient(53deg, rgba(74,197,197,1) 0%, rgba(36,147,147,1) 100%);
	margin-left: -30px;
	margin-right: -30px;

	.form-wrapper {
		width: 100%;
	}

	.form-box {
		width: 100%;
		max-width: 350px;
		box-sizing: border-box;
		margin: 20px auto;

		a {
			font-size: 12px;
			color: $text-color-accent;
			text-decoration: none;
			font-weight: 500;
		}

		.login-btn {
			width: 290px;
			background-color: $text-color-accent;
			border: none;
			color: white;

			&:hover {
				opacity: .9;
			}
		}

		.signin-box {
			font-size: 12px;
		}
	}
}

@media (max-width: 768px) {
	.layout-container .container .view.login-page {
		margin-left: -5px;
		margin-right: -5px;
		max-width: calc(100% + 10px);
	}
}

@media (max-width: 992px) {
	.form-box {
		max-width: 400px !important;
	}
}
</style>


<style lang="scss" scoped>
.el-col {
	padding-left: 30px !important;
	padding-right: 30px !important;
}
.tab-invert{
	height: 100%;
}
.white-text {
	color: white;
}
.black-text {
	color: black;
}
.ps-npr {
	background: none;
	padding:5px; 
	border: none; 
	position: absolute; 
	bottom: 20px; 
	right: 0px;
}
</style>
